import { gymListOutput, gymOutput, gymPath, gymSwitchOutput, gymUsePath, TRAINING_ROUTES, } from "@repo/contract/training";
import { getJson, sendJson, sendNoContent, } from "../core/request";
import { changeKeys } from "../plan/keys";
import { profileKeys } from "./keys";
/**
 * Several gyms (`D202`): the saved presets of the equipment checklist, and
 * "Usar esta", which writes one into the equipment in effect.
 *
 * The list, the create, the edit and the delete are ONLINE writes from the
 * profile's sheets; the switch is the one an outbox replays (`gym.use`), from
 * the readiness check, because it happens in a gym's basement with no signal.
 * A switch changes the equipment in effect, so it invalidates that section
 * and the change log beside the list.
 */
/** `GET /me/gyms`. */
export function fetchGyms(api, init) {
    return getJson(api, TRAINING_ROUTES.gyms, gymListOutput, init);
}
export function gymsOptions(api) {
    return {
        queryFn: ({ signal }) => fetchGyms(api, { signal }),
        queryKey: profileKeys.gyms,
    };
}
/** `POST /me/gyms` — 201 new, 200 a resend of the same id. */
export function createGym(api, input) {
    return sendJson(api, "POST", TRAINING_ROUTES.gyms, input, gymOutput);
}
/** `PUT /me/gyms/:id` — the whole preset. */
export function updateGym(api, input) {
    const { gymId, ...body } = input;
    return sendJson(api, "PUT", gymPath(gymId), body, gymOutput);
}
/** `DELETE /me/gyms/:id` — 204, and 204 again on a resend. */
export function deleteGym(api, gymId) {
    return sendNoContent(api, "DELETE", gymPath(gymId));
}
/** `POST /me/gyms/:id/use` — the equipment in effect becomes the gym's. */
export function switchGym(api, gymId) {
    return sendJson(api, "POST", gymUsePath(gymId), undefined, gymSwitchOutput);
}
export function createGymMutation(api) {
    return {
        invalidates: [profileKeys.gyms],
        mutationFn: (input) => createGym(api, input),
        mutationKey: ["profile", "gyms", "create"],
    };
}
export function updateGymMutation(api) {
    return {
        invalidates: [profileKeys.gyms],
        mutationFn: (input) => updateGym(api, input),
        mutationKey: ["profile", "gyms", "update"],
    };
}
export function deleteGymMutation(api) {
    return {
        invalidates: [profileKeys.gyms],
        mutationFn: (gymId) => deleteGym(api, gymId),
        mutationKey: ["profile", "gyms", "delete"],
    };
}
/** What the outbox's `gym.use` invalidates once it lands: the list (which is
 *  current), the equipment in effect, and the history of both. */
export function switchGymMutation(api) {
    return {
        invalidates: [
            profileKeys.gyms,
            profileKeys.equipment,
            profileKeys.onboarding,
            changeKeys.all,
        ],
        mutationFn: (gymId) => switchGym(api, gymId),
        mutationKey: ["profile", "gyms", "use"],
    };
}
//# sourceMappingURL=gyms.js.map